module.exports = __webpack_public_path__ + "static/qr-download-5e06ea7dbeadc44ae09899b1807b5a29.svg";